import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import Footer from "../components/Footer";
import Header from "../components/Header";
import { SupportFAQ } from "../components/FAQ";


export default function Support() 
{
  const support = [
    { title: "Création de compte", desc: "Lors de l’inscription, l’utilisateur recevra un SMS sur son numéro de téléphone contenant un code de validation pour sécuriser et confirmer la création de son compte.", icon: "bi bi-patch-check" },
    { title: "Authentification unique (SSO)", desc: "Agrospace propose un système SSO (Single Sign-On) qui permet à l’utilisateur de se connecter automatiquement à toutes les applications intégrées via la plateforme vitrine, sans avoir à ressaisir ses identifiants.", icon: "bi bi-patch-check" },
    { title: "Modification de mot de passe", desc: "En cas d’oubli, l’utilisateur peut demander la réinitialisation de son mot de passe. Un SMS contenant un code de validation sera envoyé pour sécuriser le changement et confirmer l’identité du compte.", icon: "bi bi-patch-check" },
    { title: "Support et assistance", desc: "Une équipe dédiée est disponible pour répondre aux questions techniques, commerciales ou liées à l’utilisation des applications, garantir le suivi des demandes et résoudre rapidement tout problème rencontré.", icon: "bi bi-patch-check" }
  ];

  return (
    <div className="bg-light min-vh-100">
      {/* Header's section */}
      <Header page={4} />

      {/* First section */}
      <div className="container">
        <div className="row justify-content-center py-5">
          <div className="col-md-7 py-4">
            <div className="d-flex gap-4 flex-column mb-3 border rounded-2 p-4 shadow-sm bg-green-light">
              <div className="d-flex justify-content-center align-items-center fs-6 text-success gap-3 mt-2">
                <div className="d-flex align-items-center mb-2" > <i className="bi bi-question-circle"></i> </div>
                <h1 className="lead"> Support d'aide d'Agrospace </h1>
              </div>
              <p className="text-secondary text-center px-4"> Avec le Support d’Agrospace, accédez à une assistance rapide et complète pour tirer le meilleur parti de nos applications et solutions agricoles, tout en sécurisant et optimisant vos activités. </p>
            </div>
          </div>   
        </div>    
      </div>

      {/* Support's section */}
      <div className="container pb-5 mb-5">
        <div className="row g-4">
          {support.map((item, idx) => (
            <div className="col-md-6" key={idx}>
              <div className="card h-100 rounded-3 p-4">
                <div className="d-flex gap-3 align-items-center">
                  <div className="fs-3 text-success mb-2">
                    <i className={`bi ${item.icon}`}></i>
                  </div>
                  <h5 className="fs-5 text-muted">{item.title}</h5>
                </div>
                <p className="text-muted">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* FAQ section */}
      <SupportFAQ  id={'faq'} /> 
      
      {/* Footer's section */}
      <Footer />
      
  </div>
  );
}
